export const deliveryMethods = [
  { label: 'Company van', value: 'own_van' }, { label: 'Courier', value: 'courier' },
  { label: 'Customer collection', value: 'collection' }, { label: 'Third-party delivery', value: 'third_party' },
];
export interface ShipmentOrder {
  order: { id: number; order_number: string; customer_name: string; status: string };
  items: Array<{ id: number; title: string; sku: string | null; quantity: number; shipped: number; delivered: number; planned: number; available: number }>;
  warehouses: Array<{ id: number; name: string }>;
  reservations: Array<{ order_item_id: number; warehouse_id: number; quantity: number }>;
}
export interface Shipment {
  id: string; order_id: number; order_number: string; customer_name: string; warehouse_name: string;
  delivery_method: string; provider_name: string | null; notes: string | null; status: string; revision: number;
  delivered_quantity: number;
  order_change_pending?: boolean;
  route: { stop_id: number; route_id: number; name: string | null; delivery_date: string; status: string } | null;
  receipts: Array<{ id: string; outcome: string; recipient_name: string | null; reason: string | null; created_at: string; actor_name: string; items: Array<{ order_item_id: number; title: string; sku: string | null; quantity: number }> }>;
  quantity: number; created_at: string; shopify_sync_status: string | null; tracking_number: string | null;
  lines: Array<{ order_item_id: number; sku: string | null; title: string; quantity: number; delivered: number; held?: number }>;
  events: Array<{ id: string; event_type: string; actor_name: string; details: { reason?: string }; created_at: string }>;
}
export function displayTime(value: string) {
  return new Date(value.includes('T') ? value : `${value.replace(' ', 'T')}Z`).toLocaleString();
}
